import React, { useState , useEffect, useCallback,useRef} from "react";
import Sidebar from "./AdminSidebar";
import Header from "./AdminHeader";
import DashboardPage from "./DashboardPage";
import ProfilePage from "./ProfilePage";
import FlaggedPage from "./FlaggedPage";
import SupportPage from "./SupportPage";
import AdminContact from "./AdminContact";
import { useNavigate } from "react-router-dom";
import axiosClient from "../api/axiosClient";

const AdminDashboard = () => {

  // to store userid for particular user when we clik
  const [selectedUser, setSelectedUser] = useState("SH-20260428142623432-463");

  const [active, setActive] = useState("dashboard");
  const [data, setData] = useState([]);
  const [pageIndex, setPageIndex] = useState(0);
 const [loginFilter, setLoginFilter] = useState({});
const [search, setSearch] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize] = useState(20);
     const [contact, setContact] = useState([]);

  const navigate = useNavigate();

  const searchRef = useRef(search); // ✅ add this

// keep ref in sync with state
useEffect(() => {
  searchRef.current = search;
}, [search]);

  // const token = localStorage.getItem("admintoken");
  // if(token) {
  //   return navigate("/");
  // }

// api calling for dashboard page
  const [stats,setStats] = useState({
    totalUsers :0,
    totalTestsTaken:0,
    weeklyActiveUsers : 0,
    monthlyActiveUsers : 0,
    dailyActiveUsers:0
  })


    const fetchStats = useCallback(async () => {
  try {
    const token = localStorage.getItem("admintoken");
    const res = await axiosClient.post(
      "/auth/admin/getUsersDeatils/filterWithName",
      { ...loginFilter },
      {
        params: {
          search: searchRef.current,
          page: pageIndex,
          size: pageSize,
        },
        headers: {
          Authorization: `${token}`,
        },
      }
    );

    setData(res.data.users ?? []);
    setTotalPages(res.data.totalPages ?? 0);

    console.log(setData);

    const dataa = res.data.totalNumber;
    setStats({
      totalUsers: dataa.totalUsers,
      totalTestsTaken: dataa.totalTestsTaken,
      weeklyActiveUsers: dataa.weeklyActiveUsers,
      monthlyActiveUsers: dataa.monthlyActiveUsers,
      dailyActiveUsers: dataa.totalDailyActiveUsers,
    });
  } catch (err) {
    console.log("api Error", err);
  }
}, [pageIndex, loginFilter]); // ✅ added dependency array


useEffect(() => {
  fetchStats();
}, [fetchStats]); 



  const styles = {
    body:{
margin:"0",
 padding: "0",
  minheight: "100%",
  background: "#f5f6fa",
  overflow:"hidden"
    },
    container: {
      display: "flex",
      height: "100vh",
      overflow:"hidden",
      alignitem:"stretch",
      fontFamily: "Poppins, sans-serif",
    },
   right: {
  flex: 1,
  background: "#e5e5e5",
  display: "flex",
  flexDirection: "column",
  height: "100vh",
  overflowY: "auto",
},
  };

    const handleUserClick = (userid) => {
setSelectedUser(userid);
    setActive('profile'); // switches the view
  };

  
   const token = localStorage.getItem("admintoken");
    const adminRole = localStorage.getItem("adminRole");

 useEffect(() => {
   
    if (!token) {
      navigate("/login", { replace: true });
    }
  }, [token]);

  // Prevent rendering protected UI
  if (!token) {
    return null;
  }
  

  const unreadCount = contact.filter((item) => !item.read).length;

   const renderPage = () => {
    switch (active) {
      case "dashboard":
        if (adminRole === "COLLEGE_ADMIN") return null;
        return <DashboardPage pageSize={pageSize} fetchStats={fetchStats} search={search} data={data} setLoginFilter={setLoginFilter} totalPages={totalPages} setSearch={setSearch} setPageIndex={setPageIndex} pageIndex={pageIndex} dailyActiveUsers={stats.dailyActiveUsers} monthlyActiveUsers={stats.monthlyActiveUsers} weeklyActiveUsers={stats.weeklyActiveUsers} totalTestsTaken={stats.totalTestsTaken} totalUsers={stats.totalUsers} onUserClick={handleUserClick} setSelectedUser={setSelectedUser} />;
      case "profile":
        if (adminRole === "COLLEGE_ADMIN") return null;
        return <ProfilePage  selectedUser={selectedUser} />;
      case "flagged":
        if (adminRole === "COLLEGE_ADMIN") return null;
        return <FlaggedPage />;
      case "support":
        return <SupportPage />;
      case "contact":
        return <AdminContact  />;
      default:
        return <DashboardPage />;
    }
  };

  return (
    <div style={styles.container}>
      <Sidebar unreadCount={unreadCount} active={active} setActive={setActive} />

      <div style={styles.right}>
        <Header />
        {renderPage()}
      </div>
    </div>
  );
};

export default AdminDashboard;